import { render, staticRenderFns } from "./ModalFrame.vue?vue&type=template&id=222b9dc3&scoped=true&lang=pug&"
import script from "./ModalFrame.vue?vue&type=script&lang=js&"
export * from "./ModalFrame.vue?vue&type=script&lang=js&"
import style0 from "./ModalFrame.vue?vue&type=style&index=0&id=222b9dc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222b9dc3",
  null
  
)

export default component.exports